export enum Mui {
    chipStackSpacing = 1,
    gridSpacing = 2,
    elevation = 3,
}
